/* eslint-disable max-classes-per-file */
import angular from 'angular';
// eslint-disable-next-line import/no-unresolved
import { WSAPIConstructor } from '@knitiv/api-client-javascript';

// eslint-disable-next-line import/no-cycle
import { UserModel } from '~/scripts/services/model/user';

/* globals Knitiv */

export class WsManagerSingleton {
	/**
	 * @type {WSAPIConstructor}
	 */
	static instance;

	/**
	 * @returns {WSAPIConstructor}
	 */
	static getInstance() {
		if (!WsManagerSingleton.instance) {
			WsManagerSingleton.instance = new WSAPIConstructor();
		}
		return WsManagerSingleton.instance;
	}

	/**
	 * @private
	 */
	constructor() {
		throw new Error('You can\'t initialize a singleton this way');
	}
}

/**
 *
 * @returns {Promise<WSAPIConstructor>}
 */
export const ws = () => new Promise(resolve => {
	const instance = WsManagerSingleton.getInstance();
	// eslint-disable-next-line no-promise-executor-return
	return instance.isReady() ? resolve(instance) : resolve(instance.init());
});

export default class WebsocketService {
	/* @ngInject */
	/**
	 *
	 * @param {Knitiv.RootScope} $rootScope
	 * @param {UserModel} User
	 * @param {import('angular').IQService} $q
	 */
	constructor($rootScope, User, $q) {
		this.debug = false;
		this.config = null;

		/** @type {?WSAPIConstructor} */
		this.socket = null;

		/** @type {UserModel} */
		this.User = User;
		this.$q = $q;

		/** @type {Knitiv.RootScope} */
		this.$rootScope = $rootScope;

		angular.element(document).ready(() => {
			this.start();
		});
	}

	start() {
		// On login, register socket
		this.$rootScope.$on('User.login', () => {
			// console.log('User.login');
			this.registerSocket();
		});

		// On logout, remove socket
		this.$rootScope.$on('User.logout', () => {
			if (this.socket) {
				this.socket.destroy(1000, 'User logged out');
				this.socket = null;
			}
		});

		// On normal loading, register socket
		if (this.$rootScope.context?.token) {
			this.registerSocket();
		}
	}

	async registerSocket() {
		// console.log('on login');
		this.config = this.User.getAppConfig();

		const kws = this.config.KWEBSOCKET;

		// console.log('kws', kws);

		if (!kws || !kws.url) {
			return;
		}

		try {
			const instance = WsManagerSingleton.getInstance();

			if (this.$rootScope.context?.token) {
				instance.setToken(this.$rootScope.context?.token.id);
				instance.setURL(kws.url);

				try {
					this.socket = await ws();

					this.$rootScope.$broadcast('socket:ready', this.socket);
				}
				catch (error) {
					// instance.destroy()
					// instance.getWs()?.close(1)
					console.error('e', error);
				}
			}
		}
		catch (error) {
			console.error(error);
		}
	}
}
